import { defineBatchAssignmentListFilters } from './batch-assignment.filters';

// Os filtros da lista de cessões com o cessionário por import dinâmico da porta do `fund`: a rota usa o `shape`
// no `validateSearch` e não carrega o `fund` à toa.
export const batchAssignmentListFilters = defineBatchAssignmentListFilters(() => import('@/modules/fund/public'));
